"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildingTransactionsResponseToTransactions = void 0;
var format_1 = require("@/utils/format");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
exports.buildingTransactionsResponseToTransactions = function (response, lang) {
    if (lang === void 0) { lang = LayoutState_1.Language.EN_US; }
    return response.data.items.map(function (it) { return ({
        id: it.id,
        date: format_1.default.dateSlash(new Date(it.transactionDate)),
        unit: it.flat,
        floor: it.floor,
        block: lang === LayoutState_1.Language.EN_US ? it.blockName_eng : it.blockName_chi,
        phase: '',
        name: lang === LayoutState_1.Language.EN_US ? it.buildingName_Eng : it.buildingName_Chi,
        size: it.netSize,
        sizeUnit: 's',
        price: it.salePrice,
        priceChangePercent: it.changePercentage ? it.changePercentage : 0,
        priceChangeSinceDate: it.previousSaleDate ? format_1.default.dateSlash(new Date(it.previousSaleDate)) : '',
        priceAnnualReturn: it.annualReturn ? it.annualReturn : 0,
    }); });
};
